import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/earth.pdf'; /*Change pdf*/
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {       /*Change left hand panel content*/
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
        Manuscript held by G. W. Leibniz Bibliothek, Hanover<br />
        Shelfmark LH 37, 7 Bl. 19<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
        Date: late 1677 - late 1679 (?)<br /><br />
        Translated from the Latin<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (142k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Leibniz: On the Various States of the Earth</title> {/*Change title*/}
            <meta name="description" content="An English translation of ON THE VARIOUS STATES OF THE EARTH by Gottfried Wilhelm Leibniz, from late 1677 - late 1679 (?)" /> {/*Change meta description*/}
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: ON THE VARIOUS STATES OF THE EARTH</h2> {/*Change title*/}
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br /> {/*Change page content*/}
                 [<b>LH 37, 7 Bl. 19r</b>]<br /><br />
                <center>On the Various States of the Earth</center><br /><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Two principal states can be understood: one in which the entire earth, so far as it is known to us, was liquid and mountains did not yet exist,<a name="1" href="#note1"><sup>1</sup></a> and another in which the mountains broke apart and brought about the present state of the earth. At that time, there were no land animals on the earth’s surface. Marcasites and other rocks were formed from the general liquid (containing various parts like blood) partly through sediments caused by weight and partly through quasi-fermentations caused by a permeating subtle fluid, whereby parts of the general liquid were separated. Others, however, hardened beforehand, and this can be known from the fact that sometimes the surface<a name="2" href="#note2"><sup>2</sup></a> of a solid body existing within another solid is smooth, indicating that it hardened while the surrounding liquid was still fluid. Sometimes some sticky liquid material, gradually drying out as its liquid is expelled, splits into various fissures, depending on the consistency it has thereby acquired and how unevenly it has adhered to the surrounding material. These fissures were later filled with veins of salts and metals, which hardened later. However, the material of certain metals must still lie hidden in<a name="3" href="#note3"><sup>3</sup></a> the ore itself, not all having accumulated in veins. But it is not extracted by fire because it has not yet been rendered fusible by nature; we would need that gentle menstruum analogous to the original general liquid, and the remnants of this liquid must necessarily be enclosed within bodies in various places. Water, however, is not that general liquid, but is rather its serum, born from it, which is why it is not surprising to find parts of water in crystals. But if water had been the surrounding liquid, everything would be full of water. Therefore, since everything must still be filled with the saline residues of that general liquid, although these are extremely fine and invisible, we must investigate how they can be identified and separated from the rest. Crystals and other angular bodies seem to have been dissolved in this liquid and then to have solidified, just as nitre and other salts commonly do when water evaporates.<br /><br />
                [<b>LH 37, 7 Bl. 19v</b>]<br /><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Marcasites were produced first; then the stones in which marcasites are enclosed; finally, the veins<a name="4" href="#note4"><sup>4</sup></a> of minerals that fill the fissures of stones. Sometimes crystal is enclosed within crystal, selenite within selenite; marcasite within marcasite. Earth strata were formed in this way, like strata deposited by clear water, but much more rapidly because of more violent upheavals. The initial formation of bodies is difficult to explain; their growth is easier. There is an <em>internal fluid</em> that communicates with the surrounding fluid only through openings, through which passage cannot occur without separation or propulsion. There is also an internal fluid common to several [parts], and another peculiar to each, as in the human body.<br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;The specific principle of fermentation consists in the fact that similar things adhere more readily to things that already have a definite form. Incrustations form together at the boundary between liquid and solid. If the place is concave, the outer crusts are formed first; if convex, the inner ones.
                <br /><br /><br />
                <hr className='rightcol-hr' />
                <br /><br />
                NOTES:<br /><br />
                <a name="note1" href="#1">1.</a> exist, │ the other, in which the mountains were covered by water, which subsequently │ <var>deleted</var>.<br />
                <a name="note2" href="#2">2.</a> surface │ of a hard body │ <var>deleted</var>.<br />
                <a name="note3" href="#3">3.</a> in │ rocks │ <var>deleted</var>.<br />
                <a name="note4" href="#4">4.</a> veins │ of metals │ <var>deleted</var>.<br />
               <br /><br /><br />
                  &#169; Lloyd Strickland 2023
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
